import { ADMIN_API_URL } from "../Admin/Admin";

const API = {
    VERSION: 1,
    BASE_URL: `/api`,

    getBaseUrl: function() {
        return `${this.BASE_URL}/v${this.VERSION}/`;
    },

    /**
     * Returns an api url for the given model & url.
     * Use this when you don't know exactly what module you might be getting the url for
     * In general, you should probably just use a module specific url constant
     * eg BOOKINGS_API_URL in Bookings.js
     * @param module
     * @param endpoint
     * @returns {`https://api.doordeck.com${string}/resource/`}
     */
    getUrl: function(module, endpoint = '') {

        let url = '';
        if (module === 'admin') {
            url = ADMIN_API_URL;
        } else {
            url = `${this.getBaseUrl()}${module.toLowerCase()}/`;
        }

        if (endpoint) {
            url += `${endpoint}/`
        }
        return url;
    },
}

export default API;
